'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FaxIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FaxIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Technology-Iot-Electronics-Printer--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Technology Iot Electronics Printer Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.5 20.25h-3c-0.52995 -0.0016 -1.03773 -0.2128 -1.41247 -0.5875C0.712805 19.2877 0.501583 18.7799 0.5 18.25V13.5c0.00132 -0.53 0.212458 -1.038 0.58724 -1.4128 0.37479 -0.3747 0.88273 -0.5859 1.41276 -0.5872h15.25c0.53 0.0013 1.038 0.2125 1.4128 0.5872 0.3747 0.3748 0.5859 0.8828 0.5872 1.4128v4.75c-0.0016 0.5299 -0.2128 1.0377 -0.5875 1.4125 -0.3748 0.3747 -0.8826 0.5859 -1.4125 0.5875h-3"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.5 9.5v-4h5.836c0.2652 0.00006 0.5195 0.10545 0.707 0.293l2.414 2.414c0.1875 0.18749 0.2929 0.4418 0.293 0.707V9.5"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14.75 22.5c0 0.2652 -0.1054 0.5196 -0.2929 0.7071s-0.4419 0.2929 -0.7071 0.2929H6.5c-0.26522 0 -0.51957 -0.1054 -0.70711 -0.2929C5.60536 23.0196 5.5 22.7652 5.5 22.5v-5.25h9.25v5.25Z"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          d="M3.5 14.875c-0.20711 0 -0.375 -0.1679 -0.375 -0.375s0.16789 -0.375 0.375 -0.375"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          d="M3.5 14.875c0.20711 0 0.375 -0.1679 0.375 -0.375s-0.16789 -0.375 -0.375 -0.375"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.7 7.78599c-0.0108 -0.38936 -0.1704 -0.75979 -0.4458 -1.03522 -0.2754 -0.27542 -0.6458 -0.43494 -1.0352 -0.44578"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.6 7.84301c-0.0325 -1.16728 -0.5107 -2.27782 -1.3365 -3.10354 -0.8257 -0.82572 -1.9362 -1.30394 -3.1035 -1.33645"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.6 7.84301c-0.0325 -1.16728 -0.5107 -2.27782 -1.3365 -3.10354 -0.8257 -0.82572 -1.9362 -1.30394 -3.1035 -1.33645"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M23.5 7.9c-0.0547 -1.94532 -0.8519 -3.79594 -2.228 -5.17204C19.8959 1.35187 18.0453 0.554674 16.1 0.5"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M23.5 7.9c-0.0547 -1.94532 -0.8519 -3.79594 -2.228 -5.17204C19.8959 1.35187 18.0453 0.554674 16.1 0.5"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

FaxIcon.propTypes = {
  sx: PropTypes.object
}
